export class InternCampusAdministrators {
    principalEmailAddress: string;
    principalName: string;
    mentorEmailAddress: string;
    mentorName: string;
    campusSupervisorEmailAddress: string;
    campusSupervisorName: string;
    internId: string;
    profileId: number;
}